import React from "react";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelBody from "../../../UI/Panel/PanelBody";
import TrustedPanelsTable from "../../../UI/Panels/trusted/PanelsTable";

const TrustedPanels = () => {
  return (
    <div>
      <PanelHead title="TrustedPanels" />
      <PanelBody content={<TrustedPanelsTable />} />
    </div>
  );
};

export default React.memo(TrustedPanels);
